import { Box } from '@mui/material';
import { ReceiptLongOutlined as InvoiceIcon } from '@mui/icons-material';
import { TextBlock } from '../../../Atoms/Text';
import { DEFAULT_ADVANCE_BUTTON_STYLE } from '../../../../utils/styleHelpers';
import { ZeroBaselineSkip } from './ZeroBaselineSkip';

export interface CurrentSuppliersEmptyStateProps {
  skipped: boolean;
  canEdit: boolean;
  onAdd: () => void;
  onSkip: (skipped: boolean) => void;
}

export const CurrentSuppliersEmptyState = ({ skipped, canEdit, onAdd, onSkip }: CurrentSuppliersEmptyStateProps) => (
  <Box className="flex flex-col items-center gap-2 rounded-lg border border-dashed border-grey-3 px-6 py-10 text-center">
    <Box className="mb-1 flex h-12 w-12 items-center justify-center rounded-full bg-secondary-100">
      <InvoiceIcon
        color="primary"
        fontSize="small"
      />
    </Box>
    <TextBlock
      size="base"
      weight="semibold"
      color="grey8">
      No current suppliers yet
    </TextBlock>
    <TextBlock
      size="sm14"
      color="grey6">
      Add who the client pays today so ROI Calc. has a real baseline.
    </TextBlock>
    {canEdit && (
      <button
        type="button"
        className={`${DEFAULT_ADVANCE_BUTTON_STYLE} mt-2`}
        onClick={onAdd}>
        + Add Current Supplier
      </button>
    )}
    <ZeroBaselineSkip
      skipped={skipped}
      canEdit={canEdit}
      onSkip={onSkip}
    />
  </Box>
);
